import { IconProps } from "../../types/IconType";

const EditIcon = ({ width, height, color = "#FFFFFF" }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 30 30" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path
        id="Vector"
        d="M5.50481 25.6249C5.18471 25.6249 4.91639 25.5167 4.69984 25.3001C4.48328 25.0836 4.375 24.8152 4.375 24.4951V22.3293C4.375 22.0245 4.4335 21.7339 4.5505 21.4577C4.66748 21.1814 4.82853 20.9407 5.03366 20.7356L20.863 4.91347C21.052 4.74178 21.2607 4.60911 21.4891 4.51547C21.7175 4.42182 21.957 4.375 22.2077 4.375C22.4583 4.375 22.701 4.41948 22.936 4.50844C23.1709 4.59738 23.3789 4.73879 23.56 4.93269L25.0865 6.47834C25.2804 6.65943 25.4186 6.8678 25.5011 7.10347C25.5837 7.33912 25.6249 7.57476 25.6249 7.81041C25.6249 8.06176 25.582 8.30164 25.4962 8.53003C25.4103 8.75845 25.2738 8.96717 25.0865 9.15619L9.26434 24.9663C9.05922 25.1714 8.81853 25.3325 8.54228 25.4494C8.26601 25.5664 7.97546 25.6249 7.67062 25.6249H5.50481ZM21.9399 9.61775L23.75 7.81966L22.1803 6.24997L20.3822 8.06006L21.9399 9.61775Z"
        fill={color}
      />
    </svg>
  );
};

export default EditIcon;
